/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Meta redirect tracking event
 * @export
 * @interface MetaRedirectTrackingEvent
 */
export interface MetaRedirectTrackingEvent {
    /**
     * 
     * @type {string}
     * @memberof MetaRedirectTrackingEvent
     */
    leadGenerator?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaRedirectTrackingEvent
     */
    leadPlatform?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaRedirectTrackingEvent
     */
    partnerBookingId?: string;
    /**
     * 
     * @type {number}
     * @memberof MetaRedirectTrackingEvent
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof MetaRedirectTrackingEvent
     */
    longitude?: number;
    /**
     * 
     * @type {Date}
     * @memberof MetaRedirectTrackingEvent
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MetaRedirectTrackingEvent
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof MetaRedirectTrackingEvent
     */
    address?: string;
    /**
     * 
     * @type {number}
     * @memberof MetaRedirectTrackingEvent
     */
    locationId?: number;
    /**
     * 
     * @type {string}
     * @memberof MetaRedirectTrackingEvent
     */
    category?: string;
}

/**
 * Check if a given object implements the MetaRedirectTrackingEvent interface.
 */
export function instanceOfMetaRedirectTrackingEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MetaRedirectTrackingEventFromJSON(json: any): MetaRedirectTrackingEvent {
    return MetaRedirectTrackingEventFromJSONTyped(json, false);
}

export function MetaRedirectTrackingEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetaRedirectTrackingEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'leadGenerator': !exists(json, 'leadGenerator') ? undefined : json['leadGenerator'],
        'leadPlatform': !exists(json, 'leadPlatform') ? undefined : json['leadPlatform'],
        'partnerBookingId': !exists(json, 'partnerBookingId') ? undefined : json['partnerBookingId'],
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'address': !exists(json, 'address') ? undefined : json['address'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'category': !exists(json, 'category') ? undefined : json['category'],
    };
}

export function MetaRedirectTrackingEventToJSON(value?: MetaRedirectTrackingEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'leadGenerator': value.leadGenerator,
        'leadPlatform': value.leadPlatform,
        'partnerBookingId': value.partnerBookingId,
        'latitude': value.latitude,
        'longitude': value.longitude,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'address': value.address,
        'locationId': value.locationId,
        'category': value.category,
    };
}

